import React from 'react'
import classes from './ProductsTitle.module.css'

const ProductsTitle = () => {
	return (
		<section className={classes.title}>
			<h2>Lista produktów</h2>
		</section>
	)
}

export default ProductsTitle
